module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('display', [_c('path-line', {
    attrs: {
      "file-name": "box-shadow"
    },
    slot: "path"
  }), _vm._v(" "), _c('p', {
    slot: "intro"
  }), _vm._v(" "), _c('template', {
    slot: "sections"
  }, [_c('display-section', {
    attrs: {
      "title": "Box Shadow"
    }
  }, [_c('p', {
    slot: "description"
  }, [_vm._v("\n                Box shadows can be used to portray elevation of elements. The more subtle the box shadow \n                the less elevated an element appears.\n            ")]), _vm._v(" "), _vm._l((Object.keys(this.boxShadows)), function(boxShadow) {
    return _c('example', {
      key: boxShadow,
      attrs: {
        "var-name": boxShadow
      },
      slot: "examples"
    }, [_c('div', {
      staticClass: "card",
      class: boxShadow
    }, [_vm._v(_vm._s(boxShadow))])])
  })], 2)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-38420e6b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vars/boxshadow.vue
// module id = 1453
// module chunks = 1